module.exports = __webpack_public_path__ + "static/img/41-1.3f2de7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/41-1.jpg
// module id = zr/O
// module chunks = 0